/*
 * @Author: huangzq
 * @Date: 2019-12-19 17:19:27
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-04-17 14:25:37
 * @Desc: 预览设置 弹窗
*/
<template>
  <div class="preview-set">
    <mk-drawer-biz-two
      :visible="visible"
      :append-to-body="false"
      size="660px"
      with-preview
      @open="onOpen"
      @close="onClose"
    >
      <template v-slot:title>
        <span class="fw500">
          预览&设置
        </span>
      </template>

      <div class="self-body">
        <!-- 作品标题 -->
        <div class="title">
          <mk-form
            :model="cloneMaterialData"
            label-position="left"
            :label-width="isShowCofInput?'70px':'40px'"
          >
            <mk-form-item label="标题">
              <mk-input
                v-model="cloneMaterialData.title"
                placeholder="标题"
                width="400"
                maxlength="20"
                show-word-limit
              />
            </mk-form-item>
            <mk-form-item
              v-if="isShowCofInput"
              label="发圈文案"
            >
              <mk-input
                v-model="cloneMaterialData.copyWriting"
                type="textarea"
                height="106"
                resize="none"
                maxlength="50"
                placeholder="请输入发朋友圈的文案"
                show-word-limit
              />
            </mk-form-item>

            <!-- 标签： -->
            <mk-form-item label="标签">
              <tag-select
                :key="cloneMaterialData.key"
                v-model="cloneMaterialData.tags"
                width="400"
                tip="海报的标签目前仅做分类筛选"
              />
            </mk-form-item>
          </mk-form>
        </div>
      </div>

      <template v-slot:bottom>
        <mk-button-biz @click="onClose">
          取 消
        </mk-button-biz>
        <mk-button-biz
          type="primary"
          :loading="btnLoading"
          @click="onConfirm"
        >
          确定
        </mk-button-biz>
      </template>

      <template v-slot:preview>
        <preview
          :preview-data="previewData"
          show-size
        />
      </template>
    </mk-drawer-biz-two>
  </div>
</template>

<script>
import MkDrawerBizTwo from '@components/mk-drawer-biz-two'
import Preview from '../preview/index'
import tagSelect from '@components/tag-select'

export default {
  name: 'PreviewSet',
  components: {
    MkDrawerBizTwo,
    Preview,
    tagSelect
  },
  props: {
    // 是否显示弹窗
    visible: {
      type: Boolean,
      default: false
    },
    // 海报资料数据
    materialData: {
      type: Object,
      default () {
        return {}
      }
    },
    // 其他接口promise：发布、删除、查询等
    otherApi: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      cloneMaterialData: {},
      // 保存按钮是否loading
      btnLoading: false,
      // 预览数据
      previewData: { item: {} }
    }
  },

  created () {
    this.isShowCofInput = this.util.storage.getItem('iscof')
  },

  methods: {
    // 弹窗-取消按钮事件：关闭预览和设置弹窗
    onClose () {
      if (this.visible) {
        this.$emit('update:visible', false)
      }
    },

    // 弹窗打开时，赋值最新的营销资料的数据
    onOpen () {
      this.btnLoading = false
      this.cloneMaterialData = this._.cloneDeep(this.materialData)
      this.cloneMaterialData.key = new Date().getTime()

      // 过滤掉-禁用的标签
      this.cloneMaterialData.tags = this.cloneMaterialData.showTags.map(item => {
        return item.id
      })
      this.previewData.item = this.cloneMaterialData
    },

    // 弹窗-确定按钮事件：保存设置，然后关闭弹窗
    onConfirm () {
      if (this.cloneMaterialData.title) {
        // this.onClose()
        this.btnLoading = true
        this.$emit('on-confirm', this.cloneMaterialData)
      } else {
        this.$message.error('请输入标题')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.preview-set {
  & /deep/ .el-form {
    .el-form-item__label {
      font-weight: 500;
    }
  }
}
</style>
